var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id}},[(_vm.isValid)?_c('div',{attrs:{"data-device-detection":"","data-device":_vm.properties['data-device']}},[_c('a',{class:_vm.anchorClass,attrs:{"href":_vm.properties.href,"rel":_vm.properties.rel}},[_vm._t("default",function(){return [_vm._v("Klik hier voor AR weergave")]})],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }